import React from 'react';
import { ValidationProps } from 'ui';
import { ValidationError } from 'ui/common/validation-error/validation-error';
import { ExperienceTransferTranslation } from 'app/area/experience-transfer/constants';
import { hasKeyViolationValidation } from 'app/area/experience-transfer/form/utils/validation';
import styles from './experience-transfer-messages.scss';

interface ExperienceTransferMessagesProps {
  validation: { [key: string]: ValidationProps };
  translation: ExperienceTransferTranslation;
}

export const ExperienceTransferMessages = ({ validation, translation }: ExperienceTransferMessagesProps) =>
  <div className={styles.container}>
    {hasKeyViolationValidation(validation) && <ValidationError
      title={translation.configuration_already_exists}
      subtitle={translation.configuration_change_field}
    />}
  </div>;
